import { useMutation } from '@apollo/client';
import React from 'react';
import LibraryStaffSelect from './LibraryStaffSelect';
import { REASSIGN_ORDER_ITEM_STAFF } from './graphql/Mutations';

const OrderItemStaffSelect = ({
  orderItem,
  staffRole,
  libraryId,
  isLibrary,
  disabled = false,
  onReassigned,
}) => {
  const currentUser = orderItem?.[staffRole?.field];

  const [
    reassignOrderItemStaff,
    { loading },
  ] = useMutation(REASSIGN_ORDER_ITEM_STAFF, { onError() {} });

  const handleChange = async (userId, option) => {
    if (!userId || userId === currentUser?.id) return;
    const response = await reassignOrderItemStaff({
      variables: {
        where: { ids: [orderItem?.id] },
        data: { role: staffRole?.key, userId },
      },
    });
    if (response?.data) {
      onReassigned?.(orderItem?.id, staffRole?.field, option?.user);
    }
  };

  return (
    <LibraryStaffSelect
      size="small"
      className="full-width"
      showAction={['click']}
      role={staffRole?.key}
      libraryId={libraryId}
      isLibrary={isLibrary}
      currentUser={currentUser}
      value={currentUser?.id}
      placeholder={`Select ${staffRole?.label}`}
      loading={loading}
      disabled={disabled || loading}
      onChange={handleChange}
    />
  );
};

export default OrderItemStaffSelect;
